import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hidden lg:block overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_3 = { class: "bg-white dark:bg-slate-900/50 divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  colspan: "6",
  class: "px-6 py-12 text-center text-red-600 dark:text-red-400"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { colspan: "6" }
const _hoisted_8 = { class: "text-center py-16 px-4" }
const _hoisted_9 = { class: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 mb-4" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm text-slate-500 dark:text-slate-400 mt-1"
}
const _hoisted_11 = { class: "px-6 py-4 text-sm font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_12 = { class: "px-6 py-4 max-w-xs truncate" }
const _hoisted_13 = { class: "px-6 py-4 text-sm text-slate-500 dark:text-slate-400 max-w-xs" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = { class: "truncate" }
const _hoisted_16 = {
  key: 0,
  class: "text-slate-400 italic"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "px-6 py-4 text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap" }
const _hoisted_19 = { class: "px-6 py-4" }
const _hoisted_20 = { class: "px-6 py-4" }
const _hoisted_21 = { class: "flex gap-2 justify-center" }
const _hoisted_22 = { class: "lg:hidden divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_23 = {
  key: 0,
  class: "p-4 text-center text-red-600 dark:text-red-400"
}
const _hoisted_24 = {
  key: 1,
  class: "p-8 flex justify-center"
}
const _hoisted_25 = { class: "flex justify-between items-start mb-2" }
const _hoisted_26 = { class: "font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = {
  key: 0,
  class: "group relative inline-flex ml-1"
}
const _hoisted_29 = { class: "text-sm text-slate-500 dark:text-slate-400 mb-1" }
const _hoisted_30 = { class: "flex items-center gap-2" }
const _hoisted_31 = { class: "truncate" }
const _hoisted_32 = {
  key: 0,
  class: "italic"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "text-sm text-slate-500 dark:text-slate-400 mb-3" }
const _hoisted_35 = { class: "flex gap-2 flex-wrap" }
const _hoisted_36 = {
  key: 3,
  class: "text-center py-16 px-4"
}
const _hoisted_37 = { class: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 mb-4" }
const _hoisted_38 = {
  key: 0,
  class: "text-sm text-slate-500 dark:text-slate-400 mt-1"
}

import {
	FileText, Printer, Loader2, Eye as ViewIcon,
	SquarePen as EditIcon, Trash as DeleteIcon,
	LockOpen as ActivateIcon, Lock as DeactivateIcon,
	CloudDownload as DownloadIcon, UserPen, Info
} from 'lucide-vue-next'
import CardTable from '@/components/layout/CardTable.vue'
import IconButton from '@/components/ui/IconButton.vue'
import TableLoader from '@/components/ui/TableLoader.vue'

import type { Material } from '@/config/types/material'


export default /*@__PURE__*/_defineComponent({
  __name: 'MaterialTable',
  props: {
    materials: {},
    loading: { type: Boolean },
    error: {},
    title: {},
    loadingMessage: {},
    totalUnfiltered: {}
  },
  emits: ["view", "download", "edit", "toggleStatus", "delete", "print", "editViewers"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTable, { title: __props.title }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", { class: "bg-gradient-to-r from-primary/5 via-primary/3 to-transparent dark:from-primary-dark/10 dark:via-primary-dark/5 dark:to-transparent" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[40%]" }, "File Name"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[12%]" }, "Type"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[22%]" }, "Viewers"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[10%] whitespace-nowrap" }, "Date Added"),
              _createElementVNode("th", { class: "px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[8%]" }, "Status"),
              _createElementVNode("th", { class: "px-6 py-4 text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-[8%]" }, "Quick Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_3, [
            (__props.error)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(__props.error), 1)
                ]))
              : (__props.loading)
                ? (_openBlock(), _createBlock(TableLoader, {
                    key: 1,
                    colspan: 6,
                    title: "Fetching Material"
                  }))
                : (__props.materials.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_unref(FileText), { class: "w-8 h-8 text-slate-400 dark:text-slate-500" })
                          ]),
                          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-base font-medium text-slate-600 dark:text-slate-300" }, "No records found", -1)),
                          (__props.totalUnfiltered && __props.totalUnfiltered > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Try adjusting your search or filters"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(__props.materials, (m) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: m.id,
                        class: "hover:bg-primary/5 dark:hover:bg-primary-dark/5 transition-all duration-300 ease-out group"
                      }, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(m.title), 1),
                        _createElementVNode("td", _hoisted_12, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium rounded-lg", m.type === 'Doc File' ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400' : m.type === 'Online form' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400' : m.type === 'URL Link' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400' : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'])
                          }, _toDisplayString(m.type), 3)
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.position_viewers, (viewer, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: 'pos-'+viewer.id
                                }, _toDisplayString(viewer.name) + _toDisplayString(index < (m.position_viewers?.length || 0) - 1 || (m.user_viewers?.length || 0) > 0 ? ', ' : ''), 1))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.user_viewers, (viewer, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: 'usr-'+viewer.id
                                }, _toDisplayString(viewer.first_name ? viewer.first_name + ' ' + viewer.last_name : viewer.username) + _toDisplayString(index < (m.user_viewers?.length || 0) - 1 ? ', ' : ''), 1))
                              }), 128)),
                              ((!m.position_viewers || m.position_viewers.length === 0) && (!m.user_viewers || m.user_viewers.length === 0))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "None"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.$emit('editViewers', m)), ["stop"]),
                              class: "flex-shrink-0 p-1 rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 dark:hover:bg-primary-dark/10 transition-all",
                              title: "Edit Viewers"
                            }, [
                              _createVNode(_unref(UserPen), { class: "h-4 w-4" })
                            ], 8, _hoisted_17)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(m.created_at ? new Date(m.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'N/A'), 1),
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", m.status === 'active' ? 'badge-success' : 'badge-danger'])
                          }, _toDisplayString(m.status === 'active' ? 'Active' : 'Inactive'), 3)
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(IconButton, {
                              title: "View",
                              variant: "neutral",
                              onClick: ($event: any) => (_ctx.$emit('view', m))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ViewIcon), { class: "h-4 w-4 xl:h-5 xl:w-5 text-blue-600" })
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            (m.type === 'Doc File' && m.file_path)
                              ? (_openBlock(), _createBlock(IconButton, {
                                  key: 0,
                                  title: "Download",
                                  variant: "neutral",
                                  onClick: ($event: any) => (_ctx.$emit('download', m))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DownloadIcon), { class: "h-4 w-4 xl:h-5 xl:w-5" })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (m.type === 'Doc File' && m.file_path)
                              ? (_openBlock(), _createBlock(IconButton, {
                                  key: 1,
                                  title: "Print",
                                  variant: "neutral",
                                  onClick: ($event: any) => (_ctx.$emit('print', m)
							)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Printer), { class: "h-4 w-4 xl:h-5 xl:w-5" })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(IconButton, {
                              title: "Edit",
                              variant: "primary",
                              onClick: ($event: any) => (_ctx.$emit('edit', m))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(EditIcon), { class: "h-4 w-4 xl:h-5 xl:w-5" })
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(IconButton, {
                              title: m.status === 'active' ? 'Deactivate' : 'Activate',
                              variant: m.status === 'active' ? 'warning' : 'success',
                              onClick: ($event: any) => (_ctx.$emit('toggleStatus', m))
                            }, {
                              default: _withCtx(() => [
                                (m.status === 'active')
                                  ? (_openBlock(), _createBlock(_unref(DeactivateIcon), {
                                      key: 0,
                                      class: "h-4 w-4 xl:h-5 xl:w-5"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(ActivateIcon), {
                                      key: 1,
                                      class: "h-4 w-4 xl:h-5 xl:w-5"
                                    }))
                              ]),
                              _: 2
                            }, 1032, ["title", "variant", "onClick"]),
                            (m.status != 'active')
                              ? (_openBlock(), _createBlock(IconButton, {
                                  key: 2,
                                  title: "Delete",
                                  variant: "danger",
                                  onClick: ($event: any) => (_ctx.$emit('delete', m))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(DeleteIcon), { class: "h-4 w-4 xl:h-5 xl:w-5" })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (__props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(__props.error), 1))
          : (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_unref(Loader2), { class: "w-8 h-8 animate-spin text-primary" })
              ]))
            : (__props.materials.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.materials, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: "p-4"
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(m.title), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", m.status === 'active' ? 'badge-success' : 'badge-danger'])
                      }, _toDisplayString(m.status === 'active' ? 'Active' : 'Inactive'), 3)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-lg", m.type === 'Doc File' ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400' : m.type === 'Online form' ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400' : m.type === 'URL Link' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400' : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'])
                      }, [
                        _createTextVNode(_toDisplayString(m.type) + " ", 1),
                        (m.type === 'Doc File')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                              _createVNode(_unref(Info), { class: "h-3 w-3 text-amber-600 cursor-help" }),
                              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block w-max max-w-[14rem] bg-slate-800 text-white dark:text-white text-xs rounded px-2 py-1 shadow-lg whitespace-normal text-center z-[100]" }, [
                                _createTextVNode(" Download the document, fill it out, then click Submit to upload your completed file. "),
                                _createElementVNode("span", { class: "absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-800" })
                              ], -1))
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Viewers:", -1)),
                        _createElementVNode("span", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.position_viewers, (viewer, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'pos-'+viewer.id
                            }, _toDisplayString(viewer.name) + _toDisplayString(index < (m.position_viewers?.length || 0) - 1 || (m.user_viewers?.length || 0) > 0 ? ', ' : ''), 1))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.user_viewers, (viewer, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: 'usr-'+viewer.id
                            }, _toDisplayString(viewer.first_name ? viewer.first_name + ' ' + viewer.last_name : viewer.username) + _toDisplayString(index < (m.user_viewers?.length || 0) - 1 ? ', ' : ''), 1))
                          }), 128)),
                          ((!m.position_viewers || m.position_viewers.length === 0) && (!m.user_viewers || m.user_viewers.length === 0))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "None"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('editViewers', m)), ["stop"]),
                          class: "flex-shrink-0 p-1 rounded-lg text-slate-400 hover:text-primary hover:bg-primary/10 dark:hover:bg-primary-dark/10 transition-all",
                          title: "Edit Viewers"
                        }, [
                          _createVNode(_unref(UserPen), { class: "w-4 h-4" })
                        ], 8, _hoisted_33)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, " Added: " + _toDisplayString(m.created_at ? new Date(m.created_at).toLocaleDateString() : 'N/A'), 1),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(IconButton, {
                        title: "View",
                        variant: "neutral",
                        onClick: ($event: any) => (_ctx.$emit('view', m))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ViewIcon), { class: "w-4 h-4 text-blue-600" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      (m.type === 'Doc File' && m.file_path)
                        ? (_openBlock(), _createBlock(IconButton, {
                            key: 0,
                            title: "Download",
                            variant: "neutral",
                            onClick: ($event: any) => (_ctx.$emit('download', m))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DownloadIcon), { class: "w-4 h-4" })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(IconButton, {
                        title: "Print",
                        variant: "neutral",
                        onClick: ($event: any) => (_ctx.$emit('print', m))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Printer), { class: "w-4 h-4" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(IconButton, {
                        title: "Edit",
                        variant: "primary",
                        onClick: ($event: any) => (_ctx.$emit('edit', m))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(EditIcon), { class: "w-4 h-4" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(IconButton, {
                        title: m.status === 'active' ? 'Deactivate' : 'Activate',
                        variant: m.status === 'active' ? 'warning' : 'success',
                        onClick: ($event: any) => (_ctx.$emit('toggleStatus', m))
                      }, {
                        default: _withCtx(() => [
                          (m.status === 'active')
                            ? (_openBlock(), _createBlock(_unref(DeactivateIcon), {
                                key: 0,
                                class: "w-4 h-4"
                              }))
                            : (_openBlock(), _createBlock(_unref(ActivateIcon), {
                                key: 1,
                                class: "w-4 h-4"
                              }))
                        ]),
                        _: 2
                      }, 1032, ["title", "variant", "onClick"]),
                      _createVNode(IconButton, {
                        title: "Delete",
                        variant: "danger",
                        onClick: ($event: any) => (_ctx.$emit('delete', m))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DeleteIcon), { class: "w-4 h-4" })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_unref(FileText), { class: "w-8 h-8 text-slate-400 dark:text-slate-500" })
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-base font-medium text-slate-600 dark:text-slate-300" }, "No records found", -1)),
                  (__props.totalUnfiltered && __props.totalUnfiltered > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_38, "Try adjusting your search or filters"))
                    : _createCommentVNode("", true)
                ]))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})